/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Agent_Unattended_External_Writes_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "Autonomous agents must now get human approval before performing external writes." |
*
* @param {Audit_Details_Agent_Unattended_External_Writes_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_agent_unattended_external_writes_disabled_desc = /** @type {((inputs?: Audit_Details_Agent_Unattended_External_Writes_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Agent_Unattended_External_Writes_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Autonome Agenten benötigen jetzt eine menschliche Genehmigung, bevor sie externe Schreibvorgänge ausführen.")
	return /** @type {LocalizedString} */ ("Autonomous agents must now get human approval before performing external writes.")
});